import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { SocialDistributionState } from '../types'

const groups: Getter<SocialDistributionState, RootState> = (state) => {
  return state.groups
}

export default groups
